import { render, staticRenderFns } from "./item-inventory.vue?vue&type=template&id=59983f27&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./item-inventory.vue?vue&type=script&setup=true&lang=js"
export * from "./item-inventory.vue?vue&type=script&setup=true&lang=js"
import style0 from "./item-inventory.vue?vue&type=style&index=0&id=59983f27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59983f27",
  null
  
)

export default component.exports